export const CLASS_NAME = {
    formBorder: "border border-gray-300 dark:border-gray-700 rounded-md p-4",
};